import { Input, Divider, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../index.css';
import { textFound, textNotFound } from '../colors';
import { v4 as uuidv4 } from 'uuid';
import './Home.css'; // CSS 파일을 import합니다.
import { Row, Col } from 'antd';


const { Title, Paragraph, } = Typography;

const MibVendor = () => {
  useEffect(() => {
    axios.get("/api/v1/mibvendor_cnt").then((response) => {
      setTotMibCount(response.data.data.tot_len);      
    }).catch(function (error) {

      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
  }, [])

  const [totMibCnt, setTotMibCount] = useState(null);
  const [responseResult, setResponseResult] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  const onSearch = async (value) => {
    //console.log("on search: " + value);
    if (value.includes('..') || value.includes('...') || value.includes('....') || value.includes('.....') || value.includes('......')) {
      setIsSearched(true);
    }
    else if (value.length > 0) {
      const js = { keyword: value }; // JSON 형식의 데이터
      await axios.post("/api/v1/mibvendor", js).then((response) => {
        if (response.data.status === 1) {
          console.log(response.data.data);
          setResponseResult(response.data.data);
        }
      })
        .catch(function (error) {
          console.error('Error:', error);
        });
      setIsSearched(true);
    }
  }

  const onChange = (e) => {
    //console.log('onChange:', e.target.value);
    setIsSearched(false);
    if (e.target.value.length === 0) {
      setResponseResult([])
    }
  }

  function showResult() {
    return (
      responseResult && responseResult.map((data, index) => (
        <>
          <Title style={{ color: textFound }} key={uuidv4()} level={4}> Organization : {data.z_name} </Title>
          <Title style={{ color: textFound }} key={uuidv4()} level={4}> OID : {data.z_vendor} </Title>
          <Title style={{ color: textFound }} key={uuidv4()} level={4}> Charge : {data.z_charge}</Title>
          <Title style={{ color: textFound }} key={uuidv4()} level={4}> Contact : {data.z_contact}</Title>
          <Divider></Divider>
        </>
      ))
    );
  }

  function printNotFound() {
    return (
      isSearched ? <Title style={{ color: textNotFound }} key={uuidv4()} level={3}> No manufacturer found </Title> : <></>
    )
  }

  const ShowTotMibCnt = totMibCnt===null ? (<div>loading...</div>) : (
    <Typography key={uuidv4()} variant="body2">현재까지 총 <font color="red">{totMibCnt.toLocaleString('ko-KR')}</font>개의 Vendor 정보가 저장되고 있습니다.</Typography>
    )

  return (
    <div>
      <Row justify="center">
        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
          <h2>SNMP MIB Finder</h2>
          <h4>Enter the Enterprise OID or Manufacturer name : </h4>

          <Input.Search
            placeholder='9 or 1.3.6.1.4.1.9.2.1.58 or cisco'
            style={{ marginBottom: 20, marginTop: 10, }}
            onSearch={onSearch}
            onChange={onChange}
          >
          </Input.Search>
          {ShowTotMibCnt}
          <br/>
          <Title level={3}>Result : </Title>
          <ul>
            {
              responseResult.length > 0 ? (showResult()) : (printNotFound())
            }
          </ul>
          <Divider />

          <Typography>
            <Title level={3}>SNMP MIB(Management Infomation Base)</Title>
            <Paragraph>
              SNMP(Simple NEtwork Management Protocol)는 UDP/IP를 사용하여 Ethernet 연결을 통해 네트워크 관리 작업을 수행하는 응용 계층 프로토콜 입니다.
              이때 정보를 주고 받는 집합체를 구조화 화여 MIB라고 부르며 시스템정보, 인터페이스정보, 네트워크사용량 등의 정보를 관리합니다.
              MIB은 Tree 구조 형태로 되어 있고 각 MIB 내에 포함되어 있는 개별 정보에 대한 접근은 OID(Object IDentifier)라는 고유 번호를 통해 접근할 수 있습니다.
              이러한 MIB는 IANA(Internet Assigned Number Authority)라는 단체에서 관리하며 표준을 제정하지만, 각 제조사에서도 자체적인 MIB을 가지고 있습니다.
              이를 'Enterprise(Private) MIB' 이라고 부릅니다.
            </Paragraph>
          </Typography>
        </Col>
      </Row>
    </div>
  );
}

export default MibVendor;